/**
 * Recipe id helpers for the funnel → checkout flow.
 *
 * The funnel keys recipes by their canonical product.id (UUID). The backend
 * resolves the per-channel product/variant from the channel bindings, so the
 * frontend no longer needs a hardcoded handle→variant table.
 */

/** Default energy density when per-recipe data is unavailable. */
export const DEFAULT_KCAL_PER_100G = 130;

/** A selectable recipe id is the canonical product.id (UUID). A numeric Shopify
 *  variant id is still accepted for backward compatibility with legacy drafts /
 *  the (deferred) variant-keyed account flow. */
const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const normalizeSelectedRecipes = (selected?: string[]): string[] => {
  const normalized = (selected || []).filter((id) => UUID_RE.test(id) || /^\d+$/.test(id));

  return Array.from(new Set(normalized));
};
